import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/NickName.css";

import { updateNickname } from "../api/auth";
import { getUserIdFromToken, isLoggedIn } from "../utils/jwt";
import { ensureAccessToken } from "../api/apiClient";
import { useToast } from "../context/ToastContext";

const NickName = () => {
  const navigate = useNavigate();
  const toast = useToast();
  const [nickname, setNickname] = useState("");
  const [isValid, setIsValid] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const value = e.target.value;
    setNickname(value);
    setIsValid(value.length >= 2 && value.length <= 10);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isValid || loading) return;

    if (!isLoggedIn()) {
      toast("로그인이 필요합니다.");
      navigate("/signin", { replace: true });
      return;
    }

    await ensureAccessToken();
    const userId = getUserIdFromToken();
    if (!userId) {
      toast("로그인이 필요합니다.");
      navigate("/signin", { replace: true });
      return;
    }

    try {
      setLoading(true);
      await updateNickname(nickname);
      toast("닉네임이 저장되었습니다.");
      navigate("/refrigerator");
    } catch (error) {
      toast(error.message || "닉네임을 저장하는 중 오류가 발생했습니다.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!isLoggedIn()) {
        navigate("/signin", { replace: true });
        return;
      }
      await ensureAccessToken();
      if (cancelled) return;
      if (!getUserIdFromToken()) {
        navigate("/signin", { replace: true });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [navigate]);

  return (
    <div className="nickname-page">
      <div className="nickname-card">
        <h1 className="nickname-heading">나만의 냉장고 이름</h1>
        <p className="nickname-subheading">좋아하는 별명을 정해보세요. 냉장고 리스트에서 사용돼요.</p>

        <form onSubmit={handleSubmit}>
          <div className="nickname-field">
            <label className="nickname-label">닉네임</label>
            <input
              className="nickname-input"
              name="nickname"
              placeholder="2~10자 한글 또는 영문"
              value={nickname}
              onChange={handleChange}
              maxLength={10}
            />
            {!isValid && nickname && (
              <p className="nickname-validation">2~10자 이내로 입력해주세요.</p>
            )}
          </div>

          <button className="nickname-submit-button" type="submit" disabled={!isValid || loading}>
            {loading ? "저장 중..." : "닉네임 저장"}
          </button>
        </form>

        <button className="nickname-skip-button" type="button" onClick={() => navigate("/refrigerator")}>
          나중에 할래요
        </button>
      </div>
    </div>
  );
};

export default NickName;
